<script setup lang="ts">
const { t } = useI18n()

useSeoMeta({
  title: t('pages.search.meta.title'),
  description: t('pages.index.meta.description'),
})
</script>

<template>
  <main>
    <UiBanner :title="$t('pages.search.label')" />
    <SearchPage />
  </main>
</template>
